import DataDownload from '../../core/DataDownload';
import React from 'react';
import GenerateTSV from '../../core/TSV/GenerateTSV';
import PropTypes from 'prop-types';
import workerCode from '../workers/tsv-export.js';
import { SKOS_DATATYPE_CONFIGURATION, SKOS_OBJECT_CONFIGURATION } from '../constants';
import TabbedSubmenu from '../../core/TabbedSubmenu.js';

class SchemeExport extends React.Component {

    render() {

        const { id, graph, ontologyProjectAssociation, defaultLang, sortProperty, sortNumerically,
            skosXL, annotations, examples, entitlements } = this.props;

        return (
            <TabbedSubmenu tabs={["Download Data", "Generate CSV/HTML/TSV/XLSX"]}>
                <DataDownload
                    title="Concept Scheme"
                    skosXLoption={skosXL}
                    annotationOption={annotations}
                    graph={graph}
                    resource={id}
                    exportName="taxonomyexport"
                    message="Includes data for the scheme and all concepts and labels that are part of it (in scheme)." />
                <GenerateTSV
                    ontologyProjectAssociation={ontologyProjectAssociation}
                    tsvFunction={workerCode}
                    tsvMode="conceptScheme"
                    entitlements={entitlements}
                    examples={examples}
                    graph={graph}
                    options={{
                        labelProp: 'prefLabel',
                        columns: {
                            "https://grafsync.graphifi.com/schema/tsv/hierarchy": "Hierarchy",
                            "https://grafsync.graphifi.com/schema/tsv/IRI": "IRI"
                        },
                        sortProperty,
                        sortNumerically,
                        datatypeProperties: SKOS_DATATYPE_CONFIGURATION,
                        objectProperties: Object.assign({}, SKOS_OBJECT_CONFIGURATION, {
                            "type": {
                                "displayName": "Class",
                                "iri": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                            }
                        })
                    }}
                    defaultLang={defaultLang}
                    resource={this.props.id}
                    labelsExportName="treelabels"
                    exportName="tree" />
            </TabbedSubmenu>
        );
    }
}

SchemeExport.defaulatProps = {
    skosXL: false,
    annotations: false,
    sortProperty: ""
};

SchemeExport.propTypes = {
    entitlements: PropTypes.array.isRequired,
    examples: PropTypes.array,
    sortProperty: PropTypes.string,
    sortNumerically: PropTypes.bool,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    skosXL: PropTypes.bool.isRequired,
    annotations: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    ontologyProjectAssociation: PropTypes.array
};

export default SchemeExport;